import React from "react";
import WithPopoverTip, { getRealBuyerNickName } from "../WithPopoverTip";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import WangWang from "@/components/WangWang";
import { observer } from "mobx-react-lite";
import { buildPddWebChatUrl } from "./PddBuyerUsername";

interface ManualBuyerUsernameProps {
    order: OrderDTO;

    onSearch?: () => void;
}

const ManualBuyerUsername: React.FC<ManualBuyerUsernameProps> = observer(function (props) {
    const { order, onSearch } = props;

    if (order.tags?.includes(OrderTag.ENCRYPTED_MANUAL_ORDER_DOUDIAN)) {
        const [, orderOriginalId] = order.originalId.split("-");

        if (orderOriginalId) {
            return (
                <span>
                    <WithPopoverTip onSearch={onSearch}>{getRealBuyerNickName(order)}</WithPopoverTip>

                    <a
                        href={`https://im.jinritemai.com/pc_seller_v2/main/workspace?fromOrder=${orderOriginalId}&fromGoods=`}
                        title="联系买家"
                        target="_blank"
                    >
                        <img
                            src="//img.alicdn.com/imgextra/i1/54458674/O1CN01T5BZ6t2DwkDaDOR82_!!54458674.png"
                            alt=""
                            style={{ width: 16, height: 16 }}
                        />
                    </a>
                </span>
            );
        }
    }

    if (order.tags?.includes(OrderTag.ENCRYPTED_MANUAL_ORDER_PDD)) {
        // 找到第一个 - 位置
        const dashIndex = order.originalId.indexOf("-");
        const orderOriginalId = dashIndex !== -1 ? order.originalId.substring(dashIndex + 1) : "";

        if (orderOriginalId) {
            return (
                <span>
                    <WithPopoverTip onSearch={onSearch}>{getRealBuyerNickName(order)}</WithPopoverTip>

                    <a href={buildPddWebChatUrl(orderOriginalId)} title="联系买家" target="_blank">
                        <img
                            src="//img.alicdn.com/imgextra/i4/54458674/O1CN01CuK1xF2DwkDXT4SQq_!!54458674.png"
                            alt=""
                            style={{ width: 16, height: 16 }}
                        />
                    </a>
                </span>
            );
        }
    }

    if (order.tags?.includes(OrderTag.ENCRYPTED_MANUAL_ORDER_TAOBAO)) {
        const buyerUsername = order.buyerUsername;
        const buyerNickname = order.buyerNickname;
        const bizDomain = "taobao";

        if (buyerNickname && buyerUsername) {
            return <WangWang nick={buyerNickname} openId={buyerUsername} bizDomain={bizDomain} />;
        }

        return <WangWang nick={buyerUsername} bizDomain={bizDomain} />;
    }

    return <WithPopoverTip onSearch={onSearch}>{getRealBuyerNickName(order)}</WithPopoverTip>;
});

export default ManualBuyerUsername;
